import React, { Component } from 'react'
import { Col, Row, Button, Input, FormGroup, Label } from 'reactstrap'
import PropTypes from 'prop-types'

export default class LengthInput extends Component {
  constructor(props) {
    super(props)
    const weldedLength = props.my_value * ((props.defaultValue || 0) / 100)
    this.state = {
      complete: props.existingValue != null
        ? props.existingValue
        : props.defaultValue ? Math.round(props.my_value * (props.defaultValue / 100)) : 0,
      currentWeldedLength: Math.round(props.my_value - weldedLength)
    }
  }

  static propTypes = {
    existingValue: PropTypes.number,
    my_value: PropTypes.number.isRequired,
    defaultValue: PropTypes.number,
    multipleWelds: PropTypes.bool,
  }

  handleLengthChange = (e) => {
    this.setState({ complete: Number(e.target.value) || 0 })
  }

  handlePercentClick = (percent) => {
    const complete = Math.round((this.props.my_value * percent) / 100)
    this.setState({ complete })
  }

  getPercent = () => {
    return Math.round((this.state.complete * 100) / this.props.my_value)
  }

  getCurrentPercent = () => {
    return Math.round((this.state.currentWeldedLength * 100) / this.props.my_value)
  }

  getAfterSavePercent = () => {
    const afterSaveLength = this.state.currentWeldedLength + this.state.complete
    return Math.round((afterSaveLength * 100) / this.props.my_value)
  }

  render() {
    const percent = this.getPercent()
    const currentPercent = this.getCurrentPercent()
    const afterSavePercent = this.getAfterSavePercent()
    const isMultiple = this.props.multipleWelds

    return (
      <div>
        <FormGroup>
          <Label>Length (mm)</Label>
          {isMultiple ? (
            <div>
              <p style={{ marginBottom: '15px' }}>You have selected multiple welds</p>
              <div style={{ display: 'flex', gap: '5px', marginBottom: '10px' }}>
                <Button style={{ flex: 1 }} color={percent === 100 ? 'primary' : 'secondary'} onClick={() => this.handlePercentClick(100)}>100%</Button>
                <Button style={{ flex: 1 }} color={percent === 75 ? 'primary' : 'secondary'} onClick={() => this.handlePercentClick(75)}>75%</Button>
                <Button style={{ flex: 1 }} color={percent === 50 ? 'primary' : 'secondary'} onClick={() => this.handlePercentClick(50)}>50%</Button>
                <Button style={{ flex: 1 }} color={percent === 25 ? 'primary' : 'secondary'} onClick={() => this.handlePercentClick(25)}>25%</Button>
              </div>
              <small className="text-muted">All welds will be welded at <strong>{percent}%</strong> of their length</small>
            </div>
          ) : (
            <div>
              <div style={{ marginBottom: '15px' }}>
                <p style={{ marginBottom: '5px' }}>
                  The weld has a length: <strong>{this.props.my_value} mm</strong>
                </p>
                <p style={{ marginBottom: '5px' }}>
                  Currently welded length is <strong>{this.state.currentWeldedLength} mm</strong>, which is <strong>{currentPercent}%</strong>
                </p>
              </div>
              <Row>
                <Col xs="12" sm="3">
                  <Input
                    id="complete-log-form"
                    type="number"
                    name="complete"
                    value={this.state.complete}
                    onChange={this.handleLengthChange}
                    min="0"
                    max={this.props.my_value}
                  />
                </Col>
                <Col xs="12" sm="9">
                  <div style={{ display: 'flex', gap: '5px', height: '100%' }}>
                    <Button style={{ flex: 1 }} color={percent === 100 ? 'primary' : 'secondary'} onClick={() => this.handlePercentClick(100)}>100%</Button>
                    <Button style={{ flex: 1 }} color={percent === 75 ? 'primary' : 'secondary'} onClick={() => this.handlePercentClick(75)}>75%</Button>
                    <Button style={{ flex: 1 }} color={percent === 50 ? 'primary' : 'secondary'} onClick={() => this.handlePercentClick(50)}>50%</Button>
                    <Button style={{ flex: 1 }} color={percent === 25 ? 'primary' : 'secondary'} onClick={() => this.handlePercentClick(25)}>25%</Button>
                  </div>
                </Col>
              </Row>
              <div style={{ marginTop: '10px' }}>
                <small className="text-muted">
                  After saving, the weld will be welded <strong>{this.state.currentWeldedLength + this.state.complete} mm</strong>, which is <strong>{afterSavePercent}%</strong> of its length
                </small>
              </div>
            </div>
          )}
        </FormGroup>
        <Input type="hidden" name="complete_percent" value={percent} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/EventLog/LengthInput.js